import type { FC } from 'react';

import { SECTION_IDS, TRUST_ICON_PATHS } from '@/features/home/constants/home.constants';
import { SITE_CONTAINER } from '@/features/home/constants/homeStyles.constants';
import type { SectionIntro, TrustPoint } from '@/types/home.types';

interface TrustSectionProps {
  intro: SectionIntro;
  points: TrustPoint[];
}

const TrustSection: FC<TrustSectionProps> = ({ intro, points }) => (
  <section id={SECTION_IDS.trust} className="scroll-mt-20 bg-site-bg">
    <div className={`${SITE_CONTAINER} pb-14 md:pb-[72px]`}>
      <div className="bg-site-ink p-7 text-site-bg md:p-[clamp(28px,5vw,56px)]">
        <span className="block font-site text-[13px] tracking-[0.08em] text-site-accent-mid uppercase">
          {intro.eyebrow}
        </span>

        <h2 className="mt-4 max-w-[22ch] font-site text-[clamp(30px,3.4vw,44px)] leading-[1.08] font-extrabold tracking-[-0.02em]">
          {intro.title}
        </h2>

        <ul className="mt-10 grid grid-cols-[repeat(auto-fit,minmax(min(100%,300px),1fr))] gap-x-10">
          {points.map((point) => (
            <li
              key={point.title}
              className="flex gap-4 border-t-2 border-site-bg/35 py-5"
            >
              <svg
                aria-hidden
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="square"
                strokeLinejoin="miter"
                className="shrink-0 text-site-accent-mid"
              >
                {TRUST_ICON_PATHS[point.icon].map((d) => (
                  <path key={d} d={d} />
                ))}
              </svg>

              <div>
                <h3 className="font-site text-[18px] font-extrabold">{point.title}</h3>
                <p className="mt-1 font-site text-[15px] leading-[1.5] text-site-bg/80">
                  {point.body}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default TrustSection;
